export default {
  PROPAGATE_SET_STATE: '@propagate/PROPAGATE_SET_STATE',
  PROPAGATE_DATA_REQUEST: '@propagate/PROPAGATE_DATA_REQUEST',
  PROPAGATE_CAMPAIGN_SAVE: '@propagate/PROPAGATE_CAMPAIGN_SAVE',
  PROPAGATE_CAMPAIGN_GET: '@propagate/PROPAGATE_CAMPAIGN_GET',
};
